module.exports = __webpack_public_path__ + "img/202308_06.ffc88b46.jpg";